<template>
  <li :class="{ 'lc-node-flat': flat }">
    <!--- Default question MODAL -->
    <Modal
      :width="400"
      :value="defaultQuestionModalOpen"
      ctaText="Add"
      actions-border
      overlayColor="#ffffff"
      overlayOpacity="0.83"
      @cancel="defaultQuestionModalOpen = false"
      title="Add default question"
      @confirm="confirmDefaultQuestionModal">
      <template #default>
        <label class="default-question__label"> {{ $t("shortcodes.live_chat_auto.default_question") }} </label>
        <v-select
          v-model="defaultQuestionsValue"
          class="default-question__select"
          hide-details
          :items="defaultQuestionsOption"
          :menu-props="{
            offsetOverflow: true,
            offsetY: true,
          }"
          placeholder="Default question">
        </v-select>
      </template>
    </Modal>
    <!--- Default question MODAL end-->

    <!--- Input question MODAL -->
    <Modal
      :width="400"
      :value="inputModalOpen"
      ctaText="Add"
      actions-border
      overlayColor="#ffffff"
      overlayOpacity="0.83"
      @cancel="inputModalOpen = false"
      title="Add input question"
      @confirm="confirmInputQuestionModal">
      <template #default>
        <label class="default-question__label"> {{ $t("shortcodes.live_chat_auto.default_question") }} </label>
        <v-select
          v-model="inputQuestionValue"
          class="input-question__select"
          hide-details
          :items="inputQuestionOptions"
          :menu-props="{
            offsetOverflow: true,
            offsetY: true,
          }"
          placeholder="Default question">
        </v-select>
      </template>
    </Modal>
    <!--- Input question MODAL end -->
    <span
      class="tree-item"
      :data-node-id="node.id"
      :class="{
        'tree-item--human': node.human,
        'tree-item--bot': node.human === false,
        'tree-item--question': node.messageType === 'defaultQuestion',
        'tree-item--last-message': isLastMessageInBranch,
        'tree-item--error': node._telHrefError,
      }">
      <LiveChatLinkPorts :node="node" />
      <div class="sender-indicator">
        <div class="d-flex align-center">
          <v-icon v-if="node.human" class="sender-indicator--human mr-2">mdi-account</v-icon>
          <v-icon v-else-if="node.messageType === 'defaultQuestion'" class="sender-indicator--forum mr-2">
            mdi-forum
          </v-icon>
          <v-tooltip v-else-if="node.messageType === 'decision'" top>
            <template #activator="{ on }">
              <div v-on="on">
                <v-icon class="sender-indicator--forum mr-2">mdi-eye-off-outline</v-icon>
              </div>
            </template>
            <span>This message type is not displayed to the user</span>
          </v-tooltip>

          <v-icon v-else class="sender-indicator--bot mr-2">mdi-robot</v-icon>

          <span v-if="node.messageType === 'message'">
            Message
            <v-icon v-if="isLastMessageInBranch" class="ml-1" color="green" size="16">mdi-message-arrow-right</v-icon>
          </span>
          <span class="font-semibold" v-if="node.messageType === 'defaultQuestion'">Default question</span>
          <span v-if="node.messageType === 'action'">Action</span>
          <span v-if="node.messageType === 'inputQuestion'">Input question</span>
          <span v-if="node.messageType === 'zipInputQuestion'">ZIP input question</span>
          <span v-if="node.messageType === 'decision'">Decision</span>
          <span v-if="node.messageType === 'actionItem'"
            >Action item
            <!-- Just so it's clear what is the order of the action items -->
            <span v-if="node.messageType === 'actionItem'">{{ index + 1 }}</span>
          </span>
        </div>
      </div>
      <div v-if="parent" @click="removeNode" class="remove-node">
        <v-icon>mdi-trash-can-outline</v-icon>
      </div>
      <div
        v-if="canDeleteBranch"
        @click="removeBranch"
        class="delete-branch"
        :class="{ 'delete-branch--offset': canCopyNode }">
        <v-icon>mdi-delete-sweep-outline</v-icon>
      </div>
      <div v-if="canCopyNode" @click="copyNode" class="copy-node">
        <v-icon>mdi-dock-window</v-icon>
      </div>
      <div>
        <div class="message-item">
          <LiveChatMessage
            ref="message"
            v-if="node.messageType === 'message'"
            :node.sync="node"></LiveChatMessage>
          <LiveChatAction v-if="node.messageType === 'action'" :node.sync="node"></LiveChatAction>
          <LiveChatActionItem v-if="node.messageType === 'actionItem'" :node.sync="node"></LiveChatActionItem>
          <LiveChatDefaultQuestion
            ref="defaultQuestion"
            v-if="node.messageType === 'defaultQuestion'"
            :node.sync="node"></LiveChatDefaultQuestion>
          <LiveChatInputQuestion
            ref="inputQuestion"
            v-if="node.messageType === 'inputQuestion'"
            :node.sync="node"></LiveChatInputQuestion>
          <LiveChatZipInput
            ref="zipInput"
            v-if="node.messageType === 'zipInputQuestion'"
            :node.sync="node"></LiveChatZipInput>
          <LiveChatDecision
            v-if="node.messageType === 'decision' && (!parent || parent.messageType !== 'zipInputQuestion')"
            :node.sync="node"></LiveChatDecision>
          <LiveChatZipDecision
            v-if="node.messageType === 'decision' && parent && parent.messageType === 'zipInputQuestion'"
            :node.sync="node"></LiveChatZipDecision>
        </div>
        <div class="lc-node-btns">
          <v-btn class="mr-2 lc-node-btn" v-if="displayAddMessageBtn" @click="addMessage">Add message</v-btn>
          <v-btn class="mr-2 lc-node-btn" v-if="displayAddActionBtn" @click="addAction">Add action</v-btn>
          <v-btn class="mr-2 lc-node-btn" v-if="displayAddActionItem" @click="addActionItem">Add action item</v-btn>
          <v-btn class="mr-2 lc-node-btn" v-if="displayAddInputQuestion" @click="openInputQuestionModal"
            >Add input question</v-btn>
          <v-btn class="mr-2 lc-node-btn" v-if="displayAddDecision" @click="addDecision">Add decision</v-btn>
          <v-btn class="lc-node-btn" v-if="false" @click="openDefaultQuestionModal">{{
            $t("shortcodes.live_chat_auto.add_default_question")
          }}</v-btn>
        </div>
      </div>
    </span>
    <ul v-if="!flat && node.children && node.children.length">
      <LiveChatTreeNode
        v-for="(child, index) in node.children"
        ref="children"
        :index="index"
        :key="child.id"
        :node="child"
        :parent="node"
        :lastMessageMap="lastMessageMap"
        @openModal="$emit('openModal', $event)"
        @recomputeLastMessageMap="$emit('recomputeLastMessageMap')"
        @pruneDanglingNext="$emit('pruneDanglingNext')"></LiveChatTreeNode>
    </ul>
  </li>
</template>

<script>
  import cloneDeep from "lodash/cloneDeep";
  import LiveChatMessage from "./LiveChatMessage.vue";
  import LiveChatAction from "../livechat/LiveChatAction.vue";
  import LiveChatActionItem from "../livechat/LiveChatActionItem.vue";
  import LiveChatDefaultQuestion from "../livechat/LiveChatDefaultQuestion.vue";
  import LiveChatInputQuestion from "../livechat/LiveChatInputQuestion.vue";
  import LiveChatZipInput from "../livechat/LiveChatZipInput.vue";
  import LiveChatDecision from "../livechat/LiveChatDecision.vue";
  import LiveChatZipDecision from "../livechat/LiveChatZipDecision.vue";
  import LiveChatLinkPorts from "./LiveChatLinkPorts.vue";
  import Modal from "@/components/custom/Modal.vue";
  import {
    MESSAGE,
    ACTION,
    ACTION_ITEM,
    DEFAULT_QUESTION,
    INPUT_QUESTION,
    ZIP_INPUT_QUESTION,
    DECISION,
    INPUT_QUESTION_DISPLAY_TYPES,
    ZIP_INPUT_DISPLAY_TYPES,
  } from "../livechat/constant";
  import { v4 as uuidv4 } from "uuid";
  import { normalizeIds } from "./treeGraph";

  /* eslint-disable */
  export default {
    name: "LiveChatTreeNode",
    components: {
      LiveChatMessage,
      LiveChatAction,
      LiveChatActionItem,
      LiveChatDefaultQuestion,
      LiveChatInputQuestion,
      LiveChatZipInput,
      LiveChatDecision,
      LiveChatZipDecision,
      LiveChatLinkPorts,
      Modal,
    },
    props: {
      node: {
        type: Object,
        required: true,
      },
      parent: {
        type: Object || null,
      },
      index: {
        type: Number,
      },
      lastMessageMap: {
        type: Object,
        default: () => ({}),
      },
      flat: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["openModal", "recomputeLastMessageMap", "pruneDanglingNext"],
    data() {
      return {
        defaultQuestionModalOpen: false,
        defaultQuestionsValue: "age_group",
        defaultQuestionsOption: [{ text: "Which age group are you in?", value: "age_group" }],
        // Input question modal
        inputModalOpen: false,
        inputQuestionValue: "enter_age",
        inputQuestionOptions: [
          { text: "Enter your age", value: "enter_age" },
          { text: "Enter your birth year", value: "enter_birth_year" },
          { text: "Enter your birth year (Underscore)", value: "enter_birth_year_underscore" },
          { text: "Enter ZIP code", value: "enter_zip" },
        ],
      };
    },
    computed: {
      canCopyNode() {
        if (this.node.messageType === "actionItem") return true;
        // ZIP input decisions are fixed branches — no duplicate action there.
        if (this.node.messageType === "decision") {
          return !(this.parent && this.parent.messageType === "zipInputQuestion");
        }
        return false;
      },
      canDeleteBranch() {
        return !!this.parent && Array.isArray(this.node.children) && this.node.children.length > 0;
      },
      displayAddMessageBtn() {
        // Action can't add message, only action items
        if (this.node.messageType === "action") return false;
        if (this.node.messageType === "inputQuestion") return false;
        if (this.node.messageType === "zipInputQuestion") return false;

        return true;
      },
      displayAddActionBtn() {
        // If there's already an action added, hide option to add an action
        if (this.node.children?.some(childNode => childNode.messageType === "action")) return false;
        // If there's already an input question added, hide option to add an action
        if (this.node.children?.some(childNode => childNode.messageType === "inputQuestion")) return false;
        // If there's already a ZIP input question added, hide option to add an action
        if (this.node.children?.some(childNode => childNode.messageType === "zipInputQuestion")) return false;
        // TODO:
        // If current item is action item, hide option to add an action (maybe remove this)
        if (this.node.messageType === "actionItem") return false;
        // If current item is default question, hide option to add an action (by design)
        if (this.node.messageType === "defaultQuestion") return false;
        // Action can't add action, only action items
        if (this.node.messageType === "action") return false;
        // Input question can only have a decision
        if (this.node.messageType === "inputQuestion") return false;
        // ZIP input question can only have a decision
        if (this.node.messageType === "zipInputQuestion") return false;

        return true;
      },
      displayAddActionItem() {
        if (this.node.messageType !== "action") return false;

        return true;
      },
      displayAddInputQuestion() {
        if (this.node.messageType === "action") return false;
        if (this.node.messageType === "inputQuestion") return false;
        if (this.node.messageType === "zipInputQuestion") return false;

        if (
          this.node.children?.some(
            childNode =>
              childNode.messageType === "inputQuestion" ||
              childNode.messageType === "zipInputQuestion" ||
              childNode.messageType === "action",
          )
        )
          return false;

        return true;
      },
      displayAddDecision() {
        if (this.node.messageType === "inputQuestion") return true;
        if (this.node.messageType === "zipInputQuestion") {
          return !this.node.children?.some(childNode => childNode.messageType === "decision");
        }

        return false;
      },
      isLastMessageInBranch() {
        if (this.node.messageType !== "message") {
          // Ensure isLastMessage is false for non-message nodes
          if (this.node.isLastMessage !== false) {
            this.$set(this.node, "isLastMessage", false);
          }
          return false;
        }

        if (this.node.next) {
          if (this.node.isLastMessage !== false) {
            this.$set(this.node, "isLastMessage", false);
          }
          return false;
        }

        let isLast = false;
        // Prefer map from parent if provided and node has id
        if (this.node.id && this.lastMessageMap && Object.keys(this.lastMessageMap).length > 0) {
          isLast = !!this.lastMessageMap[this.node.id];
        } else {
          // Fallback: compute locally by checking if there are any descendant messages
          isLast = !this.hasDescendantMessage(this.node);
        }

        // Set isLastMessage parameter on the node for persistence only if it has changed
        // This prevents unnecessary reactive updates that could affect editor state
        if (this.node.isLastMessage !== isLast) {
          // Use Vue.set in a way that minimizes reactivity side effects
          this.$set(this.node, "isLastMessage", isLast);
        }

        return isLast;
      },
    },
    watch: {
      "node.content"() {
        if (this.node._telHrefError) this.$delete(this.node, "_telHrefError");
      },
      "node.text"() {
        if (this.node._telHrefError) this.$delete(this.node, "_telHrefError");
      },
      "node.value"() {
        if (this.node._telHrefError) this.$delete(this.node, "_telHrefError");
      },
    },
    beforeMount() {
      this.ensureIds(this.node);
      this.ensureChildrenVariableExists(this.node);
    },
    methods: {
      ensureIds(node) {
        normalizeIds([node]);
      },
      ensureChildrenVariableExists(node) {
        if (!node.children) {
          console.warn("No children found for node", node.messageType, node.id);
          this.$set(node, "children", []);
        }
      },
      // A node has children OR `next`, never both.
      clearNext() {
        if (this.node.next) {
          this.$set(this.node, "next", null);
        }
      },
      hasDescendantMessage(node) {
        if (!node || !Array.isArray(node.children) || node.children.length === 0) return false;
        for (let i = 0; i < node.children.length; i += 1) {
          const child = node.children[i];
          if (child.messageType === "message") return true;
          if (this.hasDescendantMessage(child)) return true;
        }
        return false;
      },
      copyNode() {
        const copiedNode = cloneDeep(this.node);
        // a `next` pointing inside the copied subtree must be remapped to the new ids, else it links back to the original
        const idMap = {};
        const regenerateIds = node => {
          if (!node || typeof node !== "object") return;
          const newId = uuidv4();
          if (node.id) idMap[node.id] = newId;
          node.id = newId;
          if (Array.isArray(node.children)) node.children.forEach(regenerateIds);
        };
        const remapNext = node => {
          if (!node || typeof node !== "object") return;
          if (node.next && idMap[node.next]) node.next = idMap[node.next];
          if (Array.isArray(node.children)) node.children.forEach(remapNext);
        };
        regenerateIds(copiedNode);
        remapNext(copiedNode);
        let children = this.parent.children;
        this.parent.children = [];
        // as we clone a node, we need to access parent ref and update newly created node,
        // but with huge amount of refs its prone for mistakes and less efficient option is chosen
        this.$nextTick(() => {
          children.splice(this.index + 1, 0, copiedNode);
          this.parent.children = children;
        });
      },
      removeNode() {
        if (this.node.messageType === "actionItem" && this.node.children.length > 0) {
          this.$emit("openModal", {
            title: "Warning!",
            subtitle:
              "If an action item is deleted, all messages and other action items coming after it will also be deleted.",
            ctaText: "Delete",
            delete: true,
            index: this.index,
            parent: this.parent,
          });
        } else if (this.node.messageType === "decision" && this.node.children.length > 0) {
          this.$emit("openModal", {
            title: "Warning!",
            subtitle: "If a decision is deleted, all messages and other decision coming after it will also be deleted.",
            ctaText: "Delete",
            delete: true,
            index: this.index,
            parent: this.parent,
          });
        } else if (this.node.messageType === "action" && this.node.children.length > 0) {
          this.$emit("openModal", {
            title: "Cannot delete!",
            subtitle:
              "“Action” cannot be deleted, because it still has action items that belong to it. Action items will not function without “Action”.",
            ctaText: "Ok, understood",
            delete: false,
            cancelHidden: true,
          });
        } else if (this.node.messageType === "inputQuestion" && this.node.children.length > 0) {
          this.$emit("openModal", {
            title: "Cannot delete!",
            subtitle:
              '"Input question" cannot be deleted, because it still has decisions that belong to it. Decisions will not function without "Input question".',
            ctaText: "Ok, understood",
            delete: false,
            cancelHidden: true,
          });
        } else if (this.node.messageType === "zipInputQuestion" && this.node.children.length > 0) {
          this.$emit("openModal", {
            title: "Cannot delete!",
            subtitle:
              '"ZIP input question" cannot be deleted, because it still has decisions that belong to it. Decisions will not function without "ZIP input question".',
            ctaText: "Ok, understood",
            delete: false,
            cancelHidden: true,
          });
        } else if (this.node.children.length > 0) {
          const children = this.node.children;

          this.updateTreeContent(children, this);
          this.parent.children = children;
          this.$emit("pruneDanglingNext");
        } else {
          this.parent.children.splice(this.parent.children.indexOf(this.node), 1);
          this.$emit("pruneDanglingNext");
        }
      },
      // Deletes the node and its whole subtree (removeNode keeps children).
      removeBranch() {
        this.$emit("openModal", {
          title: "Delete branch?",
          subtitle:
            "This node and all its children (every message, action, and decision below it) will be deleted. This action cannot be undone.",
          ctaText: "Delete",
          delete: true,
          index: this.index,
          parent: this.parent,
        });
      },
      openDefaultQuestionModal() {
        this.defaultQuestionModalOpen = true;
      },
      confirmDefaultQuestionModal() {
        this.defaultQuestionModalOpen = false;
        this.addDefaultQuestion();
      },
      // Input question modal
      openInputQuestionModal() {
        this.inputModalOpen = true;
      },
      confirmInputQuestionModal() {
        this.inputModalOpen = false;
        this.addInputQuestion();
      },
      addAction() {
        this.clearNext();
        const action = cloneDeep(ACTION);
        // Ensure the new action has an ID immediately
        this.ensureIds(action);
        this.ensureChildrenVariableExists(this.node);

        if (this.node.children.length > 0) {
          const actionItem = cloneDeep(ACTION_ITEM);
          // Ensure the action item has an ID too
          this.ensureIds(actionItem);
          const children = this.node.children;
          action.children = [actionItem];
          actionItem.children = children;
          this.node.children = [action];
        } else {
          this.node.children.push(action);
        }
      },
      addActionItem() {
        this.clearNext();
        const actionItem = cloneDeep(ACTION_ITEM);
        // Ensure the new action item has an ID immediately
        this.ensureIds(actionItem);
        this.ensureChildrenVariableExists(this.node);

        this.node.children.push(actionItem);
      },
      addInputQuestion() {
        if (this.inputQuestionValue === "enter_zip") {
          this.addZipInputQuestion();
          return;
        }

        this.clearNext();
        const inputQuestion = cloneDeep(INPUT_QUESTION);
        inputQuestion.inputQuestionType = this.inputQuestionValue;

        inputQuestion.inputQuestionDisplayType =
          this.inputQuestionValue === "enter_age"
            ? INPUT_QUESTION_DISPLAY_TYPES.find(type => type.value === "age").value
            : INPUT_QUESTION_DISPLAY_TYPES.find(type => type.value === "years").value;

        this.ensureIds(inputQuestion);
        this.node.children.push(inputQuestion);
      },
      addZipInputQuestion() {
        this.clearNext();
        const zipInputQuestion = cloneDeep(ZIP_INPUT_QUESTION);
        // Set default display type to empty
        zipInputQuestion.zipInputDisplayType = ZIP_INPUT_DISPLAY_TYPES.find(type => type.value === "empty").value;
        // Ensure the new ZIP input question has an ID immediately
        this.ensureIds(zipInputQuestion);
        this.ensureChildrenVariableExists(this.node);

        this.node.children.push(zipInputQuestion);
      },
      addDecision() {
        this.clearNext();
        const decision = cloneDeep(DECISION);
        this.ensureIds(decision);
        this.node.children.push(decision);
      },
      addMessage() {
        this.clearNext();
        const message = cloneDeep(MESSAGE);
        // Ensure the new message has an ID immediately
        this.ensureIds(message);
        message.openEditorOnCreate = true;
        this.ensureChildrenVariableExists(this.node);

        if (this.node.children.length > 0) {
          const children = this.node.children;
          message.children = children;
          // In flat mode there are no child refs, so updateTreeContent is a no-op.
          this.updateTreeContent([message], this.$refs.children && this.$refs.children[0]);
          this.node.children = [message];
        } else {
          this.node.children.push(message);
        }

        // Force immediate computation of isLastMessage for new messages
        this.$nextTick(() => {
          // Trigger recompute through event emission
          this.$emit("recomputeLastMessageMap");
        });
      },
      addDefaultQuestion() {
        this.clearNext();
        const defaultQuestion = cloneDeep(DEFAULT_QUESTION);
        defaultQuestion.defaultQuestionType = this.defaultQuestionsValue;
        defaultQuestion.content = `<strong>${
          this.defaultQuestionsOption.find(option => option.value === this.defaultQuestionsValue).text
        }</strong>`;

        this.ensureIds(defaultQuestion);
        this.ensureChildrenVariableExists(this.node);

        if (this.node.children.length > 0) {
          const children = this.node.children;
          defaultQuestion.children = children;
          this.updateTreeContent([defaultQuestion], this.$refs.children && this.$refs.children[0]);
          this.node.children = [defaultQuestion];
        } else {
          this.node.children.push(defaultQuestion);
        }
      },
      // Edit at your own risk
      updateTreeContent(children, ref) {
        let index = ref?.index ? ref.index : 0;
        if (children[index].messageType === "message" && ref && ref.$refs.message) {
          ref.$refs.message.updateContent(children[index].content);
          ref.$refs.message.showEditor = !children[index].content;
          if (children[index].children?.length > 0 && ref.$refs.children) {
            this.updateTreeContent(children[index].children, ref.$refs.children[index]);
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  .sender-indicator {
    position: absolute;
    top: 10px;
    left: 10px;
    &--human {
      color: green !important;
    }
    &--bot {
      color: orange !important;
    }
    &--forum {
      color: #2377f8 !important;
    }
  }
  // Graph mode: the node is outside `.tree`, so restore what the `.tree span.tree-item` rule provided.
  .lc-node-flat {
    display: block;
    list-style: none;
    margin: 0;
    padding: 0;

    .tree-item {
      display: inline-block;
      // relative so the absolute ports/icons anchor to the box, not the outer .lc-gnode
      position: relative;
      min-width: 600px;
      max-width: 600px;
      border: solid 0.1em #666;
      border-radius: 0.2em;
    }
  }
  .tree-item {
    padding: 45px 10px 10px 10px;
    border-radius: 5px;
    &--human {
      border: 1px solid green !important;
    }
    &--bot {
      border: 1px solid orange !important;
    }
    &--question {
      border: 2px solid #2377f8 !important;
    }
    &--error {
      border: 3px dashed get-color("error") !important;
    }
  }
  .lc-node-btns {
    text-align: center;
  }

  .lc-node-btn.v-btn:not(.v-btn--round).v-size--default {
    height: 44px;
    padding: 0 24px;
    // clears the bottom-center link port
    margin-bottom: 24px;
  }

  .remove-node {
    padding: 5px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    z-index: 2;
  }

  .copy-node {
    padding: 5px 35px 5px 5px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    z-index: 1;
  }

  .delete-branch {
    padding: 5px 35px 5px 5px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    z-index: 1;

    &--offset {
      padding-right: 65px;
    }
  }

  .remove-node:hover .v-icon,
  .delete-branch:hover .v-icon {
    color: get-color("error") !important;
  }

  .copy-node:hover .v-icon {
    color: get-color("primary") !important;
  }

</style>
